module.exports = __webpack_public_path__ + "IcoAgregarCi.png";